(function() {
  if (!Shopify.designMode) {
    const productRecommendationsSection = document.querySelector('.product-recommendations');

    // Only run if the recommendations section exists on this page
    if (!productRecommendationsSection) return;

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(productRecommendationsSection);

      const url = productRecommendationsSection.dataset.url;
      if (!url) return;

      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            productRecommendationsSection.innerHTML = recommendations.innerHTML;
          }
        })
        .catch(e => {
          console.error('Error loading product recommendations:', e);
        });
    };

    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
    observer.observe(productRecommendationsSection);
  } else {
    const productRecommendationsSection = document.querySelector('.product-recommendations');

    // Only run if the recommendations section exists on this page
    if (!productRecommendationsSection) return;

    document.addEventListener('shopify:section:load', function(event) {
      const prs = document.querySelector('.product-recommendations');
      if (!prs) return;

      const url = prs.dataset.url;
      if (!url) return;

      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            prs.innerHTML = recommendations.innerHTML;
          }
        })
        .catch(e => {
          console.error('Error loading product recommendations:', e);
        });
    });

    const url = productRecommendationsSection.dataset.url;
    if (!url) return;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error('Error loading product recommendations:', e);
      });
  }
})();
